module.exports = {"meta":{"title":"Googlettomaan internetiin"},"txt":{"altTo":"Vaihtohdoksi"}};